import { render } from "./PressedWin.vue?vue&type=template&id=287b712a"
import script from "./PressedWin.vue?vue&type=script&lang=js"
export * from "./PressedWin.vue?vue&type=script&lang=js"

import "./PressedWin.vue?vue&type=style&index=0&id=287b712a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__